<template>
  <v-main>
    <v-card color="green lighten-5 fill-height">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="item.name"
                :label="$t('field.name')+'*'"
                :rules="[v => !!v || v!=null&&v.length<=150 || $t('error.lenght')]"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                counter="150"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="hash"
                :label="$t('field.hash')"
                :disabled="item.IDX!=null"
                outlined
                shaped
                background-color="yellow lighten-5"
                color="black"
                append-icon="fa-dice"
                @click:append="generateHash"
                :rules="[v => !!v || v!=null&&v.length<=3 || $t('error.lenght')]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                prepend-inner-icon="fa-cogs"
                :items="$store.getters['struct/systems']"
                :label="$t('field.system')+' (default bin) *'"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                :rules="[v => !!v || v!=null&&v.length<=3 || $t('error.lenght')]"
                v-model="item.systemid"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                prepend-inner-icon="fa-cogs"
                :items="$store.getters['struct/systems']"
                :label="$t('field.searchin')"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                multiple
                outlined
                v-model="searchin"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="frame_types"
                v-model="item.format"
                :label="$t('field.frametype')"
                outlined
                shaped
                background-color="yellow lighten-5"
                color="black"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.params"
                :label="$t('field.params')"
                background-color="yellow lighten-5"
                color="black"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="6">
              <span class="mr-4">{{$t('field.created')}}</span>
              <span class="subtitle-2 d-block">{{item.created|dt-time}}</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <span class="mr-4">{{$t('field.last_used')}}</span>
              <span class="subtitle-2 d-block">{{item.last_used|dt-time}}</span>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="3">
              <span class="mr-4">{{$t('field.used')}}</span>
              <span class="subtitle-2">{{item.used | nonull}}</span>
            </v-col>
            <v-col cols="3">
              <span class="mr-4">{{$t('field.errors')}}</span>
              <span class="subtitle-2">{{item.errors | nonull}}</span>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="$store.getters.test('FrameRecord.d')"
          color="blue darken-1"
          text
          @click="simpleDialog=true"
        >{{$t('button.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.getters.test('FrameRecord.w')"
          color="blue darken-1"
          text
          @click="save(true)"
        >{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-dialog v-model="showFrame" fullscreen>
      <v-card class="green lighten-5">
        <v-card-title>
          <span>{{generatedLink}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="showFrame=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="5">
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="fwidth" type="number" label="Frame width"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="fheight" type="number" label="Frame height"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="5">
              <iframe
                :src="generatedLink"
                allowtransparency="true"
                :width="fwidth"
                :height="fheight"
                frameborder="0"
                scrolling="no"
                class="elevation-2 yellow lighten-5"
                style="overflow:hidden;"
              ></iframe>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="subtitle-2">{{insertFrame}}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>-->
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
  </v-main>
</template>
<script>
//import axios from "axios";
import DeleteDialog from "@/components/DeleteDialog.vue";
import password from "@/password.js";
export default {
  name: "FrameEditor",
  components: { DeleteDialog },
  props: {
    record: { type: Object, required: true },
    newrec: { type: Boolean },
    value: { type: Boolean },
  },
  data() {
    return {
      // fwidth: 400,
      // fheight: 350,
      // cardlen: 0,
      // deflang: "lv",
      frame_types: [],
      showFrame: false,
      simpleDialog: false,
      showAlert: false,
      alertMessage: "",
      userRules: [(v) => !!v || this.$t("error.required")],
      item: { ...this.record },
      isnew: this.newrec,
    };
  },
  filters: {
    nonull(v) {
      return v ? v : 0;
    },
  },
  watch: {
    record: {
      handler(v) {
        this.item = { ...v };
      },
      deep: true,
    },
    newrec: {
      handler(v) {
        this.isnew = v;
      },
    },
  },
  computed: {
    searchin: {
      get() {
        return this.$api.getRule(this.item.params, "searchin", "").split(",");
      },
      set(v) {
        this.item.params = this.$api.setRule(
          this.item.params,
          "searchin",
          v.join()
        );
      },
    },
    // insertFrame() {
    //   return (
    //     '<iframe src="' +
    //     this.generatedLink +
    //     '" allowtransparency="true" width="' +
    //     this.fwidth +
    //     '" height="' +
    //     this.fheight +
    //     '" frameborder="0" scrolling="no" style="overflow:hidden;"></iframe>'
    //   );
    // },
    // card_type: {
    //   get() {
    //     console.log(this.item.format)
    //     return this.item.format ? this.item.format : 0;
    //   },
    //   set(v) {
    //     this.item.type = v;
    //   }
    // },
    hash() {
      return this.item.hashid;
    },
    // generatedLink() {
    //   let link = API; //"https://api.e-kartes.lv/info/index.html?";
    //   //let link = "http://192.168.112.114:8081?";
    //   if (this.item.hashid) link += "f=" + this.item.hashid;
    //   if (this.cardlen) link += "&cl=" + this.cardlen;
    //   if (this.deflang) link += "&l=" + this.deflang;
    //   return link;
    // }
  },
  created() {
    this.$t("admin.frame_type").forEach((e, i) => {
      this.frame_types.push({
        text: e,
        value: i,
      });
    });
  },
  methods: {
    // getRule(r, def) {
    //   try {
    //     let ret = new RegExp("<" + r + ">(.+)</" + r + ">", "gi").exec(
    //       this.item.format
    //     );
    //     return ret ? ret[1] : def;
    //   } catch (e) {
    //     return def;
    //   }
    // },
    // setRule(r, v) {
    //   try {
    //     const t = new RegExp("<" + r + ">(.+)</" + r + ">", "gi");
    //     let newval = "<" + r + ">" + v + "</" + r + ">";
    //     if (t.exec(this.item.format)) {
    //       this.item.format = this.item.format.replace(t, v ? newval : "");
    //     } else {
    //       if (v) this.item.format += newval;
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    generateHash() {
      this.item.hashid = password.generateHex(10);
    },
    close() {
      this.$emit("input", false);
    },
    erase() {
      this.$store
        .dispatch("admin/DELETE_FRAME", this.item.hashid)
        .then(() => {
          this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (this.isnew) {
        this.$store
          .dispatch("admin/INSERT_FRAME", this.item)
          .then(() => {
            this.close();
          })
          .catch((error) => {
            this.showAlertMessage(error);
          });
      } else {
        this.$store
          .dispatch("admin/UPDATE_FRAME", this.item)
          .then(() => {
            this.close();
          })
          .catch((error) => {
            this.showAlertMessage(error);
          });
      }
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped>
.last-modified {
  text-align: right;
}
</style>